// extracted by mini-css-extract-plugin
export default {"description":"p8huU4Z3Rkw_0sOJQDhy"};